import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useGetParamFromUrl = (
  param: string,
  callback: (value: string) => void,
  alwaysCallBack: boolean = false,
) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const value = params.get(param);
    if (value || alwaysCallBack) {
      callback(value || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, param]);

  const resetParam = () => {
    const params = new URLSearchParams(location.search);
    params.delete(param);
    // Preserve any other query params — only strip `param`. Use replace so
    // closing the drawer doesn't leave a dead history entry that the back
    // button would re-open.
    const search = params.toString();
    navigate(`${location.pathname}${search ? `?${search}` : ""}`, {
      replace: true,
    });
  };

  return resetParam;
};

export default useGetParamFromUrl;
